module.exports = "/assets/review_good.webp"